import ComputerList from './components/ComputerList/ComputerList';
import StarBackground from './components/StarBackground/StarBackground';
import './index.scss';

function App() {
    return (
        <div className="App">
            <StarBackground />
            <div className="appContent">
                <ComputerList />
            </div>
        </div>
    );
}

export default App;
